function ringClass(grounding) {
  const match = String(grounding || "").match(/ring\s*([1-4])/i);
  return match ? `r${match[1]}` : "";
}

export default function ReportProvenance({ grounding, freshness }) {
  if (!grounding && !freshness) return null;
  return (
    <div className="afoot pr-afoot">
      {grounding && (
        <span className={`tag ${ringClass(grounding)}`}>
          <span className="pdot" />
          {grounding}
        </span>
      )}
      {freshness && (
        <span className={`tag${/^live$/i.test(freshness) ? " live" : ""}`}>
          <span className="pdot" />
          {freshness}
        </span>
      )}
    </div>
  );
}
